//create side bar item route and export from here.
import dashboard from "./dashboard";
import ulipDashboard from "./ulipDashboard";
import toDoList from "./toDoList";
import shippingBill from "./shippingBill";
import disputeSlineDash from "./disputeSlineDash";
import purchaseDashboard from "./purchaseDashboard";
import allMaster from "./allMaster";
import transportation from "./transportation";
//import listView from "./listView";

import maintenance from "./maintenance";
import maintenanceNew from "./maintenanceNew";
import clientKycTemp from "./clientKycTemp";
import yard from "./yard";
import freightForwarding from "./freightForwarding";
import ffSeaExSlinePay from "./ffSeaExSlinePay";
import expenseApproval from "./expenseApproval";
import seaImport from "./seaImport";
import ccImport from "./CCImport";
import allModuleForm from "./allModuleForm";
import billingForm from "./billingForm";
import airFreight from "./airFreight";
import clientCCDash from "./clientCCDash";
import clientAirDash from "./clientAirDash";
import clientSeaImpDash from "./clientSeaImpDash";
import clientSeaExpDash from "./clientSeaExpDash";
import tracking from "./tracking";
import Overseas from "./overSeasAssign";
import dsrReport from "./dsrReport";
import consBooking from "./consBooking";
import agentCmsDash from "./agentCmsDash";
import lead from "./lead";
import enqPricing from "./enqPricing";
import common from "./common";
import document from "./document";
import blSubscription from "./blSubscription";
//import clientTptDash from "./clientTptDash";


//import invoice from "./invoice";
// import airImport from "./airImport";
// import airfreight from "./airFreightForward";

// import client from "./client";
// import vehicleMaster from "./vehicleMaster";
// import hubMaster from "./hubMaster";
// import driverMaster from "./driverMaster";
// import shippingLineMaster from "./shippingLineMaster";
// import yardCondition from "./yardCondition";
// import mailContentMaster from "./mailContentMaster";
// import containerMaster from "./containerMaster";
// import locationMaster from "./locationMaster";
// import vendorMaster from "./vendorMaster";
// import userManagement from "./userManagement";
// import departmentMaster from "./departmentMaster";
// import agentColoaderMaster from "./agentColoaderMaster";

// import toll from "./tollMaster";

export const sideBarItems = [
    
    allMaster,
    document,
    dashboard,
    ulipDashboard,
    blSubscription,
    toDoList,
    shippingBill,
    purchaseDashboard,
    clientKycTemp,
    lead,
    enqPricing,
    allModuleForm,
    agentCmsDash,
    common,
    consBooking,
    tracking,
    transportation,
    // invoice,
    //listView,
    freightForwarding,
    Overseas,
    seaImport,
    ffSeaExSlinePay,
    expenseApproval,
    disputeSlineDash,
    
    ccImport,
    airFreight,


    maintenance,
    billingForm,
    // maintenanceNew,
    yard,
    dsrReport,
    clientCCDash,
    clientAirDash,
    clientSeaImpDash,
    clientSeaExpDash,

    //clientTptDash,
    //airfreight,
    // vehicleMaster,
    // userManagement,
    // shippingLineMaster,
    // client,

    // hubMaster,
    // driverMaster,
    // containerMaster,
    // locationMaster,
    // vendorMaster,

    // departmentMaster,
    // toll,
    // agentColoaderMaster,
    // yardCondition,
    // mailContentMaster
];


// WEBPACK FOOTER //
// ./src/sidebar/index.js